import React from 'react';
import { ArrowRight, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { heroData } from '../data/mock';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.image}
          alt="Hope for Peace and Development"
          className="w-full h-full object-cover scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/70 to-navy/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center space-x-2 bg-forest/20 backdrop-blur-sm border border-forest/30 rounded-full px-5 py-2.5 mb-8"
          >
            <Heart className="w-4 h-4 text-forest" fill="currentColor" />
            <span className="text-sm text-white/90 font-medium font-sans">
              Basee a Bunia, Ituri - RDC
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="text-5xl sm:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 leading-[1.1] tracking-tight notranslate"
            translate="no"
          >
            {heroData.title}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-2xl sm:text-3xl text-forest font-serif font-semibold mb-6"
          >
            {heroData.subtitle}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="text-lg text-white/80 mb-10 leading-relaxed font-sans max-w-2xl"
          >
            {heroData.description}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <button
              onClick={() => navigate('/programmes')}
              data-testid="hero-discover-btn"
              className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-forest text-white font-semibold text-base hover:bg-forest/90 transition-all duration-300 shadow-lg hover:shadow-xl group"
            >
              {heroData.cta.primary}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => navigate('/don')}
              data-testid="hero-donate-btn"
              className="inline-flex items-center justify-center px-8 py-4 rounded-full border-2 border-white/40 text-white font-semibold text-base hover:bg-white hover:text-navy backdrop-blur-sm transition-all duration-300"
            >
              <Heart className="mr-2 w-5 h-5" />
              Faire un don
            </button>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
          className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-2"
        >
          <div className="w-1 h-3 bg-white/60 rounded-full" />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
